export const routes = {
  LOGIN: '/',
  HOME: '/home',
  ORGSELECT: '/org-select',
  MESSAGES: '/messages',
  USERS: '/users',
  SETTINGS: '/settings',
  IDENTITY: '/data-classification',
  LOGINQR: '/login-qr',
  ADDUSER: '/add-user',
  EDITUSER: '/edit-user/:id',
  GRIDLAYOUT: '/grid',
  GRIDCUSTOM: '/grid-custom',
  TESTSETTINGS: '/test-settings',
  PRIVACY: '/privacy',
  GAP: '/gap',
  TOS: '/tosc',
  TOSGAP: '/tos/gap',
  BOARD: '/board/:id',
  COMPLIANCE: '/compliance',
  IDENTITY2: '/identify',
  DOCUMENTATION: '/milestones-list',
  ORGANISATION: '/organisation',
};
